/* Le geste vertical doit toujours faire défiler la page.

   Symptôme corrigé : en posant le doigt au milieu d'une image, l'image se
   déplaçait et la page ne descendait plus. Deux causes cumulées — le glisser
   natif des images, et l'absence de touch-action sur les conteneurs de médias.

   Le CSS fait l'essentiel (voir tiloa-brand.css). Ce fichier ne s'occupe que
   de ce que le CSS ne peut pas faire : l'attribut draggable, que Firefox est
   seul à ne pas couvrir via -webkit-user-drag.

   On ne touche à aucun carrousel : les galeries de Dawn défilent nativement,
   le navigateur sait déjà distinguer un geste vertical d'un geste horizontal.
   Ajouter un second script tactile par-dessus ne ferait que créer des
   conflits.
*/
(function () {
  'use strict';

  var ZONES = [
    '.product__media-list',
    '.product-media-container',
    '.thumbnail-list',
    '.tiloa-medias',
    '.gamelle-presell',
    '.tiloa-vcard',
    '.card__media',
    '[class*="carrousel"]',
  ];

  // Le suffixe doit être ajouté à CHAQUE zone : « .a,.b img » ne viserait que
  // les images de .b, et poserait l'attribut sur .a lui-même.
  var SELECTEUR = ZONES.map(function (z) { return z + ' img, ' + z + ' video'; }).join(',');

  function desactiverGlisser(racine) {
    var imgs = (racine || document).querySelectorAll(SELECTEUR);
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('draggable', 'false');
    }
  }

  desactiverGlisser(document);

  // Les galeries et les sections différées arrivent après le premier rendu.
  if (document.body) {
    var enAttente = false;
    new MutationObserver(function () {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(function () { enAttente = false; desactiverGlisser(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
